var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-resource',{attrs:{"booking_id":_vm.booking_id,"resource":_vm.resource,"headers":_vm.headers,"element_list":_vm.form_content,"data-decoration":_vm.decor}})}
var staticRenderFns = []

export { render, staticRenderFns }